/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./RecruiterDashboard.scss";
import AssessmentKits from "./components/AssessmentKits";
import { Spinner, Modal } from "react-bootstrap";
import CompleteProfileStep from "../../../_uiComponents/CompleteProfileStep";
import MainLayout from "../../../_components/Common/MainLayout";
import useRecruiterDashboard from "./useRecruiterDashboard";

export default (props) => {
  const {
    assessmentKits,
    assesmentKitsLoading,
    userMetaData,
    resumeUploadModal,
    isResumeUpload,

    onEditAssessmentKitClick,
    onViewAssessmentsClick,
    onViewCandidatesClick,
    handleResumeUploadModal,
    onResumeUpload,
  } = useRecruiterDashboard();
  
  return (
    <MainLayout activeMenuItem="home" pageName="Dashboard">
      <div className="mentor-dashboard-new bg-grey-4 position-relative footer-gap">
        <div className="hiring-board">
          <div className="container">
            <div className="row mb-3 mx-0">
              <div className="col-md-12">
                <div className="dashboard-component-container border border-6 p-2 h-100 bg-white">
                  <div className="row mx-0 justify-content-between  align-items-center">
                    <div className="col-md-6">
                      {
                        userMetaData?.user_details && (
                          <CompleteProfileStep
                            user={userMetaData}
                            handleResumeUploadModal={handleResumeUploadModal}
                          />
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 pb-4">
                <AssessmentKits
                  assessmentKits={assessmentKits}
                  assesmentKitsLoading={assesmentKitsLoading}
                  onEditAssessmentKitClick={onEditAssessmentKitClick}
                  onViewAssessmentsClick={onViewAssessmentsClick}
                  onViewCandidatesClick={onViewCandidatesClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={resumeUploadModal}
        centered
        onHide={() => handleResumeUploadModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Resume Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please Upload Your Resume</p>

          {isResumeUpload ? (
            <Spinner variant="primary" />
          ) : (
            <input
              className="form-control bg-transparent pb-2 h-auto"
              type="file"
              name="resume"
              accept=".pdf"
              onChange={onResumeUpload}
            />
          )}
        </Modal.Body>
      </Modal>
    </MainLayout>
  );
};
